import { InjectionToken, NgZone, type NgModuleRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import type { AppModule } from '../app.module';

export const navigateTo$ = new Subject<string>();
export type GeotabCredentials = {
  database: string;
  sessionId: string;
  userName: string;
};
export type GeotabState = {
  getState: () => any;
  setState: (v: any) => void;
  gotoPage: (page: string, params: any) => void;
};
export const GEOTAB_STATE = new InjectionToken<GeotabState>('GEOTAB_STATE');
export const GEOTAB_DATABASE = new InjectionToken<string>('GEOTAB_DATABASE');
export const GEOTAB_FAKE_BASE_URL = 'https://ride.view';
export function getGeotabPageHash(): string {
  const hash = window.location.hash.substring(1);
  const geotabPageHash = hash.includes(',') ? hash.substring(0, hash.indexOf(',')) : hash;
  return geotabPageHash;
}
export function subscribeNavigateToListnerForGeotab(ngModuleRef: NgModuleRef<AppModule>): void {
  const $ = navigateTo$.subscribe((url) => {
    const router = ngModuleRef.injector.get(Router);
    const ngZone = ngModuleRef.injector.get(NgZone);
    ngZone.run(() => {
      router.navigateByUrl(url, { replaceUrl: !url });
    });
  });
  ngModuleRef.onDestroy(() => {
    $.unsubscribe();
  });
}
export function performInitialNavigationForGeotab(ngModuleRef: NgModuleRef<AppModule>): void {
  const geotabState = ngModuleRef.injector.get(GEOTAB_STATE);
  const url: string = geotabState.getState().rideViewUrl || '';
  navigateTo$.next(url);
}
